<template lang='haml'>
  .admin-users
    %v-layout.row
      %v-flex.mb-5
        %filter-bar{ ":search": "search", "@filterUsers": "filterUsers($event)", "@search": "searchFor($event)" }
    %v-layout.row
      %v-flex.xs12
        %table.fancy
          %thead
            %tr
              %th.line-num
              %th.left-align Name / Company
              %th.left-align Email
              %th.left-align Role
              %th.left-align Created
              %th.left-align Updated
              %th.left-align Last Log In
              %th Actions
          %tbody
            %tr{ "v-if": "users.length <= 0" }
              %td.line-num
              %td.center-align{ colspan: 7 }
                No users found
            %tr{ "v-else": "", "v-for": "(user, index) in users", ":key": "index" }
              %template{ "v-if": "!user.disabled_at" }
                %td.line-num {{index + 1}}
                %td
                  %v-avatar.left.mr-2{ size: 30, "v-if": "user.avatar_url" }
                    %img{ ":src": "user.avatar_url", alt: "" }
                  .username {{user.full_name}} ({{user.id}})
                  .company {{user.company_name}}
                %td {{user.username}}
                %td {{user.role}}
                %td {{user.created_at | moment('MM/DD/YYYY hh:mm')}}
                %td {{user.updated_at | moment('MM/DD/YYYY hh:mm')}}
                %td {{user.login_at | moment('MM/DD/YYYY hh:mm')}}
                %td.center-align.no-wrap
                  .btn-group
                    %v-tooltip{ bottom: true, "v-if": "user.session_token" }
                      %v-btn{ icon: true, slot: "activator", ":href": "'/?t=' + user.session_token", target: "_blank" }
                        %v-icon mdi-login-variant
                      %span User Login
                    %v-tooltip{ bottom: true }
                      %v-btn{ icon: true, slot: "activator", ":to": "'/admin/users/' + user.id", target: "_blank" }
                        %v-icon mdi-pencil
                      %span Edit Profile
                    %v-tooltip{ bottom: true }
                      %v-btn{ icon: true, slot: "activator", "@click": "disableUser(user.id)"}
                        %v-icon mdi-account-off
                      %span Disable User
                    %v-tooltip{ bottom: true }
                      %v-menu{ slot: "activator" }
                        %v-btn{ icon: true, slot: "activator" }
                          %v-icon mdi-dots-vertical
                        %v-list
                          %v-list-tile{ "v-for": "(feature) in features", "@click": "toggleFeature(user, feature.name)", ":key": "feature.id" }
                            %v-icon{ ":color": "featureColor(user, feature.name)" } {{feature.icon}}
                            &nbsp;
                            %span {{feature.name}}
                      %span Feature Flags
</template>

<style lang="sass">
  .avatar
    width: 32px
  .username
    font-weight: 600
    display: inline-block
</style>

<script>
  import api from '@/api/gungho'
  import FilterBar from './filter-bar'

  export default {
    metaInfo () {
      return {
        title: 'Users'
      }
    },

    components: {
      filterBar: FilterBar
    },

    data () {
      return {
        users: false,
        search: '',
        filter: '',
        buttonToggle: 'all',
        features: [
          { icon: 'mdi-source-repository', name: 'API' },
          { icon: 'mdi-account-box-multiple', name: 'Proxy' },
          { icon: 'mdi-store', name: 'Store' }
        ]
      }
    },

    methods: {
      featureColor (user, name) {
        if (!user) return 'black'
        return user.features.includes(name.toLowerCase()) ? 'blue' : 'grey'
      },

      toggleFeature (user, name) {
        if (this.featureColor(user, name) === 'blue') {
          api.adminUserRemoveFeatureFlag(user.id, name)
          user.features.splice(
            user.features.indexOf(name.toLowerCase()), 1
          )
        } else {
          api.adminUserAddFeatureFlag(user.id, name)
          user.features.push(name.toLowerCase())
        }

        console.log('Features: ', user.features)

        return true
      },

      async disableUser (id) {
        await api.userDisable(id)
        this.filterUsers()
      },

      filterUsers (filter) {
        if (filter) this.filter = filter
        if (!this.search) this.search = ''
        if (!this.filter) this.filter = 'all'
        console.log('Filtering on:', this.filter, 'Searching for:', this.search)
        api.adminUsers({search: this.search, filter: this.filter}).then((data) => {
          this.users = data.users
        })
      },

      searchFor (str) {
        console.log('Search For: ', str)
        this.search = str
        this.filterUsers()
      },

      loadUsers () {
        api.adminUsers().then((data) => { this.users = data.users })
      }
    },

    beforeMount () {
      this.loadUsers()
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?1a3a0618